import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/deploy-frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/deploy-frontend/src/app/[lang]/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AmplitudeContextProvider"] */ "/home/jenkins/workspace/prod/deploy-frontend/src/contexts/AmplitudeContext/AmplitudeContext.tsx");
